import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';
import { GoogleMapComponentDef, IMarkerOptions } from '@df/module-google-maps/google-map/google-map.component.def';
declare module '@df/module-google-maps/google-map/google-map.component.def' {
    interface IMarkerOptions {
        storeId?: number;
    }
}
@Component({
    selector: 'google-map',
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: '',
    standalone: true
})
export class GoogleMapComponent extends GoogleMapComponentDef {
    @Output()
    storeSelected = new EventEmitter<number>();
    protected onMarkerClick(markerSetup: IMarkerOptions, marker: google.maps.Marker): void {
        const storeId = markerSetup.storeId;
        if (storeId != undefined) {
            this.storeSelected.emit(storeId);
        }
    }
}
